/** Decode locally, preserve orientation, remove metadata and bound the transmitted image. */
export async function prepareChatImage(file: File): Promise<string> {
  if (!file.size || file.size > 20 * 1024 * 1024) throw new Error("Elige una foto de hasta 20 MB.");
  if (!/^image\//.test(file.type)) throw new Error("Selecciona un archivo de imagen.");
  const url = URL.createObjectURL(file);
  const image = new Image();
  let timer: ReturnType<typeof setTimeout> | undefined;
  try {
    await new Promise<void>((resolve, reject) => {
      timer = setTimeout(() => reject(new Error("La foto tarda demasiado en abrirse. Inténtalo de nuevo.")), 15000);
      image.onload = () => resolve();
      image.onerror = () => reject(new Error("No se pudo abrir la foto. Prueba con JPEG, PNG o WebP."));
      image.src = url;
    });
    const width = image.naturalWidth, height = image.naturalHeight;
    if (!width || !height || width * height > 80_000_000) throw new Error("La foto tiene dimensiones no compatibles.");
    const scale = Math.min(1, 2048 / Math.max(width, height));
    const canvas = document.createElement("canvas");
    canvas.width = Math.max(1, Math.round(width * scale));
    canvas.height = Math.max(1, Math.round(height * scale));
    const context = canvas.getContext("2d");
    if (!context) throw new Error("No se pudo preparar la foto.");
    context.fillStyle = "#ffffff";
    context.fillRect(0, 0, canvas.width, canvas.height);
    context.drawImage(image, 0, 0, canvas.width, canvas.height);
    const result = canvas.toDataURL("image/jpeg", 0.9);
    if (!result.startsWith("data:image/jpeg;base64,") || result.length > 6_900_000) throw new Error("La foto es demasiado grande. Prueba con una más pequeña.");
    return result;
  } finally {
    clearTimeout(timer);
    image.onload = null;
    image.onerror = null;
    image.src = "";
    URL.revokeObjectURL(url);
  }
}
